<div class="content">
  <div class="content-header">
    <div class="title-primary">{{'PatientSearchPrimaryTitle' | cpLoginTranslate | async}}</div>
    <div class="title-secondary">{{'PatientSearchSecondaryTitle' | cpLoginTranslate | async}}</div>
  </div>

  <app-web-form-light-container class="web-form"
                          *ngIf="showForm"
                          [URL]="patientSearchURL"
                          #SearchPatientForm
                          (dataValidated)="dataValidated($event)">
  </app-web-form-light-container>

  <div class="buttons-wrapper">
    <cp-button class="primary-button call-to-action" captionToTranslate="Continue.Login.PP" [disabled]="!patientDataValidated || continueClicked" (onClick)="continue()"></cp-button>
  </div>
</div>
